export const API_URL = "https://apiprod.bookzy.app";

// LOCAL DEV URL
export const API_URL_1 = "http://63.34.147.105:5000";

// DEV URL
// export const API_URL_1 = "https://bmcapi-dev.bookzy.app/dev";
export const profileDefaultAvatar = "https://bmcapp.s3.eu-west-1.amazonaws.com/assets/DefaultAvatar.png";

export const defaultServerImage = "https://bmcapp.s3.eu-west-1.amazonaws.com/assets/DefaultAvatar.png";
export const S3_BUCKET_NAME = "bmcapp";
export const S3_ACCESS_KEY_ID = "AKIA5EIADQFZC72DHT6P";
export const S3_SECRET_ACCESS_KEY = "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";
export const S3_REGION = "eu-west-1";
export const GOOGLE_MAPS_API = "AIzaSyBoaBW9HXkaHd0cJpIMev52Ek__wJgHH90";
export const defaultAvailablePaymentMethods = {
  "payAtVenue": {
    "enable": false,
    "processingFeeApplicable": true,
    "reserveNowPaylater": true,
    "paymentGatewayServiceFee": {
      "paymentProcessingFlatFee": 0,
      "paymentProcessingPercentage": 0
    }
  },
  "tikkie": {
    "enable": true,
    "allowAccess": false,
    "processingFeeApplicable": true,
    "paymentGatewayServiceFee": {
      "paymentProcessingFlatFee": 0,
      "paymentProcessingPercentage": 0
    }
  },
  "ideal": {
    "enable": false,
    "processingFeeApplicable": true,
    "paymentGatewayServiceFee": {
      "paymentProcessingFlatFee": 0.29,
      "paymentProcessingPercentage": 0
    }
  },
  "applePay": {
    "enable": true,
    "processingFeeApplicable": true,
    "paymentGatewayServiceFee": {
      "paymentProcessingFlatFee": 0.25,
      "paymentProcessingPercentage": 1.5
    }
  },
  "googlePay": {
    "enable": true,
    "processingFeeApplicable": true,
    "paymentGatewayServiceFee": {
      "paymentProcessingFlatFee": 0.25,
      "paymentProcessingPercentage": 1.5
    }
  },
  "creditCard": {
    "enable": true,
    "processingFeeApplicable": true,
    "paymentGatewayServiceFee": {
      "paymentProcessingFlatFee": 0.25,
      "paymentProcessingPercentage": 2.5
    }
  },
  "bookzyPlatformFee": {
    "enable": true,
    "processingFeeApplicable": true,
    "flatFee": 0.19,
    "percentageFee": 0
  }
}

export const displayAvailablePaymentMethods = {
  "NA": "NA",
  "Not Applicable": "Not Applicable",
  "payAtVenue": "Pay At Venue",
  "tikkie": "Tikkie",
  "ideal": "Ideal",
  "applePay": "Apple Pay",
  "googlePay": "Google Pay",
  "creditCard": "Credit Card",
  "bookzyPlatformFee": "bookzyPlatformFee",
  "classPass": "Not Applicable",
  "eventPass": "Event Pass",
  "servicePass": "Service Pass",
  "Cash": "Cash",
}
export const dashboardStatsFilter = [
  { value: "today", title: "Today" },
  { value: "thisWeek", title: "Last Week" },
  { value: "thisMonth", title: "Last Month" },
]
export const bookingStatusFilter = [
  { value: "all", title: "All Bookings" },
  { value: "confirmed", title: "Confirmed" },
  { value: "cancelled", title: "Cancelled" },
  { value: "refunded", title: "Refunded" },
]

export const guestsFilter = [
  { value: "all", title: "All Guests" },
]

export const statusColors = {
  "draft": { //draft
    borderWidth: 0,
    borderColor: "#D7BB294D",
    color: "#8C780C",
    backgroundColor: "#D7BB294D"
  },
  "false": { //draft
    borderWidth: 0,
    borderColor: "#D7BB294D",
    color: "#8C780C",
    backgroundColor: "#D7BB294D"
  },
  "trialing": { //draft
    borderWidth: 0,
    borderColor: "#D7BB294D",
    color: "#8C780C",
    backgroundColor: "#D7BB294D"
  },
  "published": { //published
    borderWidth: 0,
    borderColor: "#468C111F",
    color: "#468C11",
    backgroundColor: "#468C111F" //#468C111F
  },
  "true": { //published
    borderWidth: 0,
    borderColor: "#468C111F",
    color: "#468C11",
    backgroundColor: "#468C111F" //#468C111F
  },
  "active": { //published
    borderWidth: 0,
    borderColor: "#468C111F",
    color: "#468C11",
    backgroundColor: "#468C111F" //#468C111F
  },
  "cancelled": {
    borderWidth: 0,
    borderColor: "#ff404033",
    color: "#FF4040",
    backgroundColor: "#ff404033" // #ff404033
  },
  "canceled": {
    borderWidth: 0,
    borderColor: "#ff404033",
    color: "#FF4040",
    backgroundColor: "#ff404033" // #ff404033
  },
  "refunded": {
    borderWidth: 0,
    borderColor: "#ff404033",
    color: "#FF4040",
    backgroundColor: "#ff404033"
  }
};

export const progressColors = ['bg-pink-400', 'bg-red-400', 'bg-slate-500', 'bg-indigo-500']

export const sellerTypes = [
  { value: "marketplace", title: "Marketplace" },
  { value: "individual_reseller", title: "Individual Reseller" },
  { value: "venue_box_office", title: "Venue Box Office" },
  { value: "influencer", title: "Influencer" },
  { value: "social_media_ad", title: "Social Media Ad/Boost" },
  { value: "email_campaign", title: "Email campaign" },
  { value: "promotion_company", title: "Promotion Company" },
];

export const commissionType = {
  "flatFeePerTicket": "Fixed Fee Per Ticket",
  "percentageOnTicketPrice": "Percentage On Ticket Price",
};
